import { render, staticRenderFns } from "./createDish.vue?vue&type=template&id=b076af26&scoped=true"
import script from "./createDish.vue?vue&type=script&lang=js"
export * from "./createDish.vue?vue&type=script&lang=js"
import style0 from "./createDish.vue?vue&type=style&index=0&id=b076af26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b076af26",
  null
  
)

export default component.exports